import {DecimalPipe} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core'
import {filter} from 'rxjs/operators'
import {HemnetService} from '../../services/hemnet.service'

@Component({
  selector: 'spb-calculation',
  templateUrl: './calculation.component.html',
  styleUrls: ['./calculation.component.scss'],
  imports: [DecimalPipe]
})
export class CalculationComponent implements OnInit {
  public monthlyCost = 0
  public loanAmount = 0
  public interest = 0
  public runCost = 0
  public amortization = 0
  public fee = 0
  public taxDeduction = 0
  public amortizationPercent = 0
  private readonly hemnetService = inject(HemnetService)

  private readonly rates = [
    {rate: 0.5, value: 0.01},
    {rate: 0.7, value: 0.02}
  ]

  public ngOnInit(): void {
    this.hemnetService.hemnetData.pipe(
      filter(hemnetData => hemnetData && !!hemnetData.expectedPrice)
    ).subscribe(
      {
        next: hemnetData => {
          hemnetData.runCost = hemnetData.runCost || 0
          hemnetData.fee = hemnetData.fee || 0
          const loanAmount = hemnetData.expectedPrice - hemnetData.downPayment
          const interestRate = hemnetData.interestRate / 100
          const yearlyInterest = loanAmount * interestRate
          const monthlyInterest = Math.ceil(yearlyInterest / 12)
          let monthlyTaxDeduction = Math.ceil(monthlyInterest * 0.30)
          if (yearlyInterest > 100000) {
            monthlyTaxDeduction = Math.ceil((30 * 1000 + ((yearlyInterest - (100 * 1000)) * 0.20)) / 12)
          }
          this.loanAmount = loanAmount
          this.fee = hemnetData.fee

          this.amortization = Math.ceil((hemnetData.expectedPrice - hemnetData.downPayment) *
            this.getAmortizationPercent(hemnetData.expectedPrice, hemnetData.downPayment) / 12)
          this.runCost = Math.ceil(hemnetData.runCost / 12)
          this.interest = monthlyInterest
          this.taxDeduction = monthlyTaxDeduction
          this.monthlyCost = this.fee + this.amortization + this.runCost + this.interest - this.taxDeduction
        }
      })
  }

  private getAmortizationPercent(price: number, downPayment: number): number {
    const degree = (price - downPayment) / price
    this.amortizationPercent = this.rates.reduce((current: number, rate: any) => degree > rate.rate ? rate.value : current, 0)
    return this.amortizationPercent
  }
}
